import { Pipe, PipeTransform, inject } from '@angular/core'
import { Maybe, ProductServiceValueType } from '@generated/sammathnaur.graphql'
import { TranslateService } from '@ngx-translate/core'
import { constantCase } from 'change-case'

@Pipe({
  name: 'translateProductServiceValueType',
  standalone: false
})
export class TranslateProductServiceValueTypePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService)

  public transform(productServiceValueType?: Maybe<ProductServiceValueType>): string {
    return this.translateService.instant(`TRANSLATE_PRODUCT_SERVICE_VALUE_TYPE.${constantCase(productServiceValueType || ProductServiceValueType.Fixed)}`)
  }
}
